export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_MEDIA_PATH =
  'https://carmatec.blob.core.windows.net/te-announcements/Images/';
export const FADING_EFFECT_KEY = process.env.REACT_APP_FADING_EFFECT_KEY;
export const SCROLL_OVERFLOW_RESET_KEY =
  process.env.REACT_APP_SCROLL_OVERFLOW_RESET_KEY;
export const FULL_PAGE_LICENSE_KEY =
  process.env.REACT_APP_FULL_PAGE_LICENSE_KEY;
export const PROJECT_FILE_DOWNLOAD_URL =
  process.env.REACT_APP_PROJECT_FILE_DOWNLOAD_URL;
export const RENTAL_FILE_DOWNLOAD_URL =
  process.env.REACT_APP_RENTAL_FILE_DOWNLOAD_URL;
export const PRODUCT_FILE_DOWNLOAD_URL =
  process.env.REACT_APP_PRODUCT_FILE_DOWNLOAD_URL;
export const PRODUCT_NEWS_DOWNLOAD_URL =
    process.env.REACT_APP_NEWS_FILE_DOWNLOAD_URL;
export const CURRENT_COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE;
export const CURRENT_SITE_URL = process.env.REACT_APP_SITE_URL;
export const ENVIRONMENT_TYPE = process.env.REACT_APP_CUSTOM_NODE_ENV;
export const CURRENCY_TYPE = process.env.REACT_APP_CURRENCY;
